import { parseImgUrlToken } from "src/filter/modules/img";
import * as utils from "src/store/utils";
const { setPrintArrayContent } = utils;
import { enumToFilter } from 'src/common/global-enum'
import { m60SizeMap } from '../../../production-process/simpleWoven/woven-config'
const height = '6mm';
export function setInfo1(info) {
	return {
		style: {
			fontSize: '3mm',
			flexDirection: "column",
			flex: 'none',
			padding:'0 5mm'
		},
		children: [
			{
				children: [
					{
						style: {
							flexDirection: "column",
							flex: 'none',
							width: '30%',
						},
						children: [
							{
								text: '前后款式图', 	
								style: {
									textAlign: 'center',
									flex: 'none',
									width: '100%',
									borderRight: 'none'
								}
							},
							{
								style: {
									textAlign: 'center',
									borderTop: 'none',
									borderRight: 'none'
								},
								render(h, inner) {
									return <img style='height: 35mm;max-width: 100%;' src={parseImgUrlToken(info.frontBackImg)}></img>;
								}
							},

						]
					},
					{
						style: {
							flexDirection: "column"
						},
						children: [
							{
								text: '版型及缝制修改要求', 
								style: {
									textAlign: 'center',
									flex: 'none',
									width: '100%'
								}
							},
							{
								style: {
									flexDirection: "column",
									// flex: 'none'
								},
								children: setPrintArrayContent([
									{
										text: '针数',
										propsName: 'needles', 
										style: {
											height,
											width: '15mm',
											flex: 'none',
											borderRight: 'none',
											borderTop: 'none'
										}
									},
									{
										text: '成品重量',
										propsName: 'weight', 
										style: {
											height,
											width: '15mm',
											flex: 'none',
											borderRight: 'none',
											borderTop: 'none'
										}
									},
									{
										text: '面料名称', 
										propsName: 'fabricName',
										style: {
											height,
											borderRight: 'none',
											borderTop: 'none'
										}
									},
									{
										text: '纱织规格', 
										propsName: 'spec',
										style: {
											height,
											width: '20mm',
											flex: 'none',
											borderRight: 'none',
											borderTop: 'none'
										}
									},
									{
										text: '成分', 
										propsName: 'component',
										style: {
											height,
											borderTop: 'none'
										}
									}
								], info.fabricList || [], 5)
							},

						]
					}
				]
			},
			{
				style: {
					flexDirection: "column",
					flex: 'none',
				},
				children: [
					{
						text: '颜色/尺码/数量', 
						style: {
							textAlign: 'center',
							borderTop: 'none'
						}
					},
					{
						style: {
							borderRight: '1px solid',
						},
						children: ((info) => {
							if(info.originDemandsList.length > info.productDemandsList.length) {
								const leftArray = setColorTable(info.originDemandsList);
								const rightArray = setColorTable(info.productDemandsList).reduce((pre, next) => {
									if (next.children) {
										next.children.splice(0, 1);
									}
									pre.push(next)
									return pre
								}, []);
								return [
									setInfo('原始订单数量', leftArray, '60%'),
									setInfo('生产订单数', rightArray, '40%'),
								]
							} else {
								const leftArray = setColorTable(info.productDemandsList);
								const rightArray = setColorTable(info.originDemandsList).reduce((pre, next) => {
									if (next.children) {
										next.children.splice(0, 1);
									}
									pre.push(next)
									return pre
								}, []);
								return [
									setInfo('生产订单数', leftArray, '60%'),
									setInfo('原始订单数量', rightArray, '40%'),
								]
							}

							function setInfo(title, array, width) {
								return {
									style: {
										flexDirection: "column",
										width: width,
										flex: 'none',
									},
									children: [
										{
											text: title,
											style: {
												textAlign: 'center',
												flex: 'none',
												width: '100%',
												height: '6mm',
												borderRight: 'none',
												borderTop: 'none',
											}
										},
										{
											style: {
												flexDirection: "column",
											},
											children: array
										}
									]
								}
							}
							function setColorTable(list) {
								const array = [];
								let count = 0;
								list.forEach((item, $i) => {
									const innerArray = [];
									let innerCount = 0;
									item.forEach((inner, $inner_i) => {
										if ($inner_i !== 0) {
											innerCount = Number(innerCount) + Number(inner)
										}
										innerArray.push({
											style: {
												height,
												width: $inner_i === 0 ? '40mm' : 'auto',
												flex: $inner_i === 0 ? 'none' : '1',
												borderRight: 'none',
											borderTop: 'none'
											},
											text: inner
										})
									})
									innerArray.push({
										style: {
											height,
											borderRight: 'none',
											borderTop: 'none'
										},
										text: $i === 0 ? '小计' : innerCount
									})
									array.push({
										children: innerArray
									})
									if ($i !== 0) count = count + innerCount
								})
								if (list.length > 0 && list.length < 6) {
									for (let i = list.length; i < 6; i++) {
										const childList = (() => {
											const array = [];
											const obj1 = {
												style: {
													height,
													width: '40mm',
													flex: 'none',
													borderRight: 'none',
													borderTop: 'none'
												},
												text: ''
											}
											const obj2 = {
												style: {
													height,
													width: 'auto',
													flex: '1',
													borderRight: 'none',
													borderTop: 'none'
												},
												text: ''
											}
											list[0].forEach((item, $index) => {
												array.push($index === 0 ? obj1 : obj2)
												// array.push(obj1)
											})
											array.push(obj2)
											return array
										})()

										array.push({
											children: childList
										})
									}
								}
								if (list.length > 0) {
									array.push({
										children: ((list) => {
											const innerList = [];
											list.map((item, $index) => {
												if ($index === 0) return innerList.push({
													style: {
														height,
														width: '40mm',
														flex: 'none',
														borderRight: 'none',
														borderTop: 'none'
													},
													text: '合计'
												})
												innerList.push({
													style: {
														height,
														borderRight: 'none',
														borderTop: 'none'
													},
													text: ''
												})
											})
											innerList.push({
												style: {
													height,
													borderRight: 'none',
													borderTop: 'none'
												},
												text: count
											})
											return innerList
										})(list[0])
									})

								}
								return array
							}
						})(info)
					}
				]
			},
			{
				style: {
					flexDirection: "column",
					fontSize: '3mm',
					borderRight: '1px solid'
				},
				children: setPage1Table(info)
			},
			{
				children: [
					{
						style: {
							borderRight: 'none',
							borderTop: 'none'
						},
						text: '复核:'
					},
					{
						style: {
							borderRight: 'none',
							borderTop: 'none'
						},
						text: '内检:'
					},
					{
						style: {
							borderTop: 'none'
						},
						text: '打印日期:' + new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString('it-IT')
					},
				]
			}
		]
	}
}
function setPage1Table(info, table1Size=24) {
	const isBrandCodeSix  = info.brandCode == '6'
	return setPrintArrayContent([
		{
			text: '部位',
			propsName: 'usedPosition',
			style: {
				minHeight:'10mm',
				height: 'auto',
				width: '30mm',
				flex: 'none',
				borderRight: 'none',
				borderTop: 'none',
			},
			itemStyle: {
				minHeight:'4mm',
				height: 'auto',
				width: '30mm',
				flex: 'none',
				borderRight: 'none',
				borderTop: 'none'
			}
		},
		{
			text: '度法',
			propsName: 'degreeMethod',
			style: {
				minHeight:'10mm',
				height: 'auto',
				width: '45mm',
				flex: 'none',
				borderRight: 'none',
				borderTop: 'none'
			},
			itemStyle: {
				minHeight:'4mm',
				height: 'auto',
				width: '45mm',
				flex: 'none',
				borderRight: 'none',
				borderTop: 'none'
			}
		},
		{
			text: '+/-',
			propsName: 'increaseOrDecrease',
			style: {
				minHeight:'10mm',
				height: 'auto',
				borderRight: 'none',
				borderTop: 'none'
			},
			itemStyle: {
				minHeight:'4mm',
				height: 'auto',
				borderRight: 'none',
				borderTop: 'none'
			}
		},
		{
			text: '备注',
			propsName: 'remark',
			style: {
				minHeight:'10mm',
				height: 'auto',
				borderRight: 'none',
				borderTop: 'none'
			},
			itemStyle: {
				minHeight:'4mm',
				height: 'auto',
				borderRight: 'none',
				borderTop: 'none'
			}
		},
		...info.sizeCodeList.map(item => {
			return {
				render(h) {
					const has = m60SizeMap[item.sizeName];
					const isBrandSIXSizeCodeMap = {
						"XS": '欧洲XXS',
						"S": "欧洲XS",
						"M":"欧洲S",
						"L":"欧洲M",
						"XL":"欧洲L",
						"XXL":"欧洲XL",
						"XXXL":"欧洲XXL",
					}
					let  brandSixSizeName
					if(item.sizeName.indexOf('纸样尺寸') >-1 || item.sizeName.indexOf('样衣尺寸') >-1){
						brandSixSizeName = ''
					}else{
						brandSixSizeName = isBrandSIXSizeCodeMap[item.sizeName.replace(/[\u4e00-\u9fa5]/gm, '')]
					}
					return (!isBrandCodeSix ?<div>
						<p>{item.sizeName}</p>
						{has && <p>{has}</p>}
					</div>:<div
						style={{'line-height': '12px','text-align': 'center'}}>
						<p>{item.sizeName.replace(/[\u4e00-\u9fa5]/gm, '')}</p>
						<p>{item.sizeName.replace(/[^\u4e00-\u9fa5]/gm, '')}</p>
						{brandSixSizeName && <p>{brandSixSizeName}</p>}
					</div>)
				},
				propsName: item.sizeName,
				style: {
					minHeight:'10mm',
					height: 'auto',
					borderRight: 'none',
					borderTop: 'none'
				},
				itemStyle: {
					// minHeight: itemStyleHeight,
					// height: 'auto',
					minHeight:'7mm',
					height: 'auto',
					borderRight: 'none',
					borderTop: 'none'
				}
			}
		}),
		/*...((list) => {
      return info.sizeCodeList.map(item => {
        return {
          text: item.sizeName,
          propsName: item.sizeCode,
          style: {
            height
          },
          format(row) {
            return row.sizeMap[item.sizeName]
          }
        }
      })
    })(info.sizeCodeList)*/
	], info.sizeItemList.map(item => {
		return {
			...item,
			...item.sizeMap
		}
	}), table1Size)
}


export function setInfo2(info, enumList) {
	const enumListShow = enumToFilter(enumList)
	return {
		style: {
			flexDirection: "column",
			padding:'0 5mm',
		},
		children: [
			{
				style: {
					flex: 'none',
					borderBottom: '1px solid'
				},
				children: [
					{
						style: {
							flex: 'none',
							height: '16mm',
							lineHeight: '16mm',
							borderRight: 'none',
							borderBottom: 'none'
						},
						textStyle: this.zoomStyle,
						text: `版型:`
					},
					{
						style: {
							height: '16mm',
							lineHeight: '12mm',
							flex: 1,
							flexDirection: "column",
						},
						children: [
							{
								style: {
									height: '16mm',
									lineHeight: '0mm',
									flex: 1,
									fontSize: '3mm',
									// width: '80%'
								},
								textStyle: this.zoomStyle,
								children: [
									{
										style: {
											// borderRight: 'none'
										},
										render() {
											return (
												<div>
													<base-checkbox style={{ 'font-size': '3mm' }} label="上装:" v-model={info.pattern} multiple={true} readOnly={false} options={[
														{
															comment: '紧身',
															code: '紧身'
														},
														{
															comment: '合体',
															code: '合体'
														},
														{
															comment: '宽松',
															code: '宽松'
														},
														{
															comment: 'Oversize',
															code: 'Oversize'
														},
													]}></base-checkbox>
												</div>
											)
										}
									}
								]
							},
							{
								style: {
									height: '16mm',
									lineHeight: '0mm',
									flex: 1,
									fontSize: '3mm'
									// width: '80%'
								},
								textStyle: this.zoomStyle,
								children: [
									{
										style: {
											borderTop: 'none',
											borderBottom: 'none',
										},
										render() {
											return (
												<div>
													<base-checkbox style={{ 'font-size': '3mm' }} label="下装:" v-model={info.pattern} multiple={true} readOnly={false} options={[
														{
															comment: '高腰',
															code: '高腰'
														},
														{
															comment: '中腰',
															code: '中腰'
														},
														{
															comment: '低腰',
															code: '低腰'
														},
													]}></base-checkbox>
												</div>
											)
										}
									}
								]
							}
						]
					},
				]
			},
			{
				children: [
					{
						style: {
							flexDirection: "column",
						},
						children: [
							...(info.detailItemList || []).map(item => {
								return {
									style: {
										flexDirection: "column",
									},
									children: [
										{
											text: enumListShow[item.usedPosition],
											textStyle: this.zoomStyle,
											style: {
												borderBottom: 'none',
												height: '8mm',
												flex: 'none',
												width: '100%',
												borderTop: 'none',
												// borderRight: 'none'
											}
										},
										{
											render(h, inner) {
												return <img style='height: 100%;' src={parseImgUrlToken(item.imgUrl)}></img>;
											},
											style: {
												borderBottom: 'none',
												borderTop: 'none',
												height: '65mm',
												flex: 'none',
												width: '100%',
												textAlign: 'center'
												// borderRight: 'none'
											}
										},
										{
											text: item.methodRemark,
											textStyle: this.zoomStyle,
											style: {
												borderTop: 'none',
												height: '6mm',
												flex: 'none',
												width: '100%',
											}
										}
									]
								}
							})
						]
					},
					{
						style: {
							flexDirection: "column",
							borderRight: '1px solid'
						},
						children: [
							{
								style: {
									flexDirection: "column",
									flex: 'none',
									width: '100%',
								},
								children: [
									{
										text: '样衣数量说明',
										textStyle: this.zoomStyle,
										style: {
											border: 'none',
											height:'5mm',
											flex: 'auto'
										}
									},
									{
										text: info.sampleQuantityDescription,
										textStyle: this.zoomStyle,
										style: {
											borderTop: 'none',
											borderRight: 'none',
											borderLeft: 'none',
											height: '35mm',
											flex: 'auto',
											color: '#000'
										}
									}
								]
							},
							{
								style: {
									flexDirection: "column",
									flex: 'none',
									width: '100%'
								},
								children: [
									{
										text: '风险评估',
										textStyle: this.zoomStyle,
										style: {
											border: 'none',
											height:'5mm',
											flex: 'auto'
										}
									},
									{
										text: info.riskAssessment,
										textStyle: this.zoomStyle,
										style: {
											borderTop: 'none',
											borderRight: 'none',
											borderLeft: 'none',
											height: '34mm',
											flex: 'auto',
											color: '#000'
										}
									}
								]
							},
							{
								style: {
									flexDirection: "column",
									flex: 'none',
									width: '100%'
								},
								children: [
									{
										text: '修改意见',
										textStyle: this.zoomStyle,
										style: {
											border: 'none',
											height:'5mm',
											flex: 'auto'
										}
									},
									{
										text: info.confirmSamplePattern,
										textStyle: this.zoomStyle,
										style: {
											borderTop: 'none',
											borderRight: 'none',
											borderLeft: 'none',
											height: '33mm',
											flex: 'auto',
											color: '#000'
										}
									}
								]
							},
							{
								style: {
									flexDirection: "column",
									flex: 'none',
									width: '100%'
								},
								children: [
									{
										text: '大货注意事项及品质说明',
										textStyle: this.zoomStyle,
										style: {
											border: 'none',
											height:'5mm',
											flex: 'auto'
										}
									},
									{
										text: info.qualityRequirementsDescription,
										textStyle: this.zoomStyle,
										style: {
											borderTop: 'none',
											borderRight: 'none',
											borderLeft: 'none',
											height: '36mm',
											flex: 'auto',
											color: '#000'
										}
									}
								]
							},
							{
								style: {
									flexDirection: "column",
									flex: 'none',
									width: '100%'
								},
								children: [
									{
										text: '特殊工艺说明',
										textStyle: this.zoomStyle,
										style: {
											border: 'none',
											height:'5mm',
											flex: 'auto'
										}
									},
									{
										text: info.specialProcessDescription,
										textStyle: this.zoomStyle,
										style: {
											borderTop: 'none',
											borderRight: 'none',
											borderLeft: 'none',
											height: '35mm',
											flex: 'auto',
											color: '#000'
										}
									}
								]
							},
							{
								style: {
									flexDirection: "column",
									flex: 'none',
									width: '100%'
								},
								children: [
									{
										text: '拼撞料说明',
										textStyle: this.zoomStyle,
										style: {
											border: 'none',
											height:'5mm',
											flex: 'auto'
										}
									},
									{
										text: info.bumpDescription,
										textStyle: this.zoomStyle,
										style: {
											borderTop: 'none',
											borderRight: 'none',
											borderLeft: 'none',
											height: '34mm',
											flex: 'auto',
											color: '#000'
										}
									}
								]
							},
						]
					}
				]
			},
			{
				// children: [
				// 	{
				// 		style: {
				// 			borderRight: 'none',
				// 		},
				// 		text: '复核:'
				// 	},
				// 	{
				// 		style: {
				// 			borderRight: 'none',
				// 		},
				// 		text: '内检:'
				// 	},
				// 	{
				// 		text: '打印日期:' + new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString('it-IT')
				// 	},
				// ]
			}
		]
	}
}
